import { Control, Controller } from 'react-hook-form';

import { useTranslate } from '@i18n';
import { Box, u, Spinner, Stack, Text, Select } from '@ui';

import * as css from '../UserWelcomeWizard.css';
import { UserWelcomeWizardForm } from '../useUserWelcomeWizard';

type CoachStepProps = {
    control: Control<UserWelcomeWizardForm>;
    coachOptions: Array<{ value: string; label: string }>;
    isLoading: boolean;
};

export const CoachStep = ({ control, coachOptions, isLoading }: CoachStepProps) => {
    const t = useTranslate();

    return (
        <Controller
            control={control}
            name="coachIds"
            render={({ field }) => (
                <Box className={css.sectionCard}>
                    {isLoading ? (
                        <Box display="flex" justifyContent="center" p={u(4)}>
                            <Spinner size="m" />
                        </Box>
                    ) : (
                        <Stack gap={u(2)}>
                            <Text variant="pSmall" color="muted">
                                {t('user_welcome_wizard.coach_optional')}
                            </Text>
                            <Select
                                options={coachOptions}
                                selectedValues={field.value}
                                onChange={field.onChange}
                                placeholder={t('user_welcome_wizard.coach_placeholder')}
                                label={t('user_welcome_wizard.coach_label')}
                                searchBox
                                multiple
                                width="100%"
                            />
                        </Stack>
                    )}
                </Box>
            )}
        />
    );
};
